// Zustand
import { create } from "zustand"
import paymentInstallmentsServices from "../../../services/payment/installments"

// Services

// ---------------------------------------------|| PROFILE - STORE ||----------------------------------------------------

const usePaymentInstallmentStore = create(set => ({
  getInquiryInstallmentPayment: (FacilityRequestId) => {
    return paymentInstallmentsServices.getInquiryInstallmentPayment(FacilityRequestId)
  },
  getinquiryInstallmentPaymentWithoutLogin: data => {
    return paymentInstallmentsServices.getinquiryInstallmentPaymentWithoutLogin(data)
  },

  installmentPaymentPin: data => {
    return paymentInstallmentsServices.installmentPaymentPin(data)
  },

  installmentPaymentPinWithoutLogin: data => {
    return paymentInstallmentsServices.installmentPaymentPinWithoutLogin(data)
  },

  installmentPayment: data => {
    return paymentInstallmentsServices.installmentPayment(data)
  },

  installmentPaymentWithoutLogin: data => {
    return paymentInstallmentsServices.installmentPaymentWithoutLogin(data)
  }
}))

export default usePaymentInstallmentStore
